"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _authorisation = _interopRequireDefault(require("../authorisation"));

var _projectDetailLink = _interopRequireDefault(require("../project-detail-link"));

var _unauthorized = _interopRequireDefault(require("../project-detail-link/unauthorized"));

var _gitChangesetLink = _interopRequireDefault(require("../git-changeset-link"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var ProjectStatusList = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectStatusList, _React$Component);

  function ProjectStatusList(props) {
    var _this;

    _classCallCheck(this, ProjectStatusList);

    _this = _possibleConstructorReturn(this, (ProjectStatusList.__proto__ || Object.getPrototypeOf(ProjectStatusList)).call(this, props));
    _this.state = {
      isLoading: false,
      projects: []
    };
    _this.projectDetailLink = _this.projectDetailLink.bind(_assertThisInitialized(_this));
    _this.projectChangeSetLink = _this.projectChangeSetLink.bind(_assertThisInitialized(_this));
    _this.projectColumns = [{
      title: props.t('project'),
      prop: 'project'
    }, {
      title: props.t('changeset'),
      render: _this.projectChangeSetLink
    }, {
      title: '',
      render: _this.projectDetailLink
    }];
    _this.staticTexts = {
      noData: props.t('no data'),
      loading: props.t('loading data')
    };
    return _this;
  }

  _createClass(ProjectStatusList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-project-status-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.props.anchorId
      }, t('Projects')), /*#__PURE__*/_react.default.createElement(_datalist.default, {
        keys: ['projectKey'],
        withControls: false,
        enableSort: false,
        initialData: this.state.projects,
        columns: this.projectColumns,
        staticTexts: this.staticTexts,
        isLoading: this.state.isLoading
      }));
    }
  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      var projects,
          statusData = [];
      this.setState({
        isLoading: true
      }); // Get projects

      fetch("/api/".concat(this.props.i18n.language, "/projects"), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (projectsJSON) {
        projects = projectsJSON; // Get status, NOTICE in future change props.user for multiple users

        return fetch("/api/".concat(_this2.props.i18n.language, "/users/").concat(_this2.props.userId, "/status"), {
          credentials: 'include'
        });
      }).then(_fetchUtils.default.checkStatus).then(function (statusJSON) {
        var farm = statusJSON.farm;
        statusData = projects.filter(function (project) {
          if (!statusJSON[project.project_key]) return false;
          return _this2.props.ignoreProject !== project.project_key;
        }).map(function (project) {
          var projectKey = project.project_key;
          return {
            id: statusJSON[projectKey].id,
            changeSet: statusJSON[projectKey].changeSet,
            farmId: farm.id,
            project: project.name,
            projectKey: projectKey
          };
        });

        _this2.setState({
          projects: statusData,
          isLoading: false
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "projectDetailLink",
    value: function projectDetailLink(val, row) {
      var _this$props = this.props,
          t = _this$props.t,
          history = _this$props.history,
          i18n = _this$props.i18n;
      var DetailLink = new _authorisation.default(['admin', 'projectresponsible', 'cantonresponsible'], [row.projectKey], true)(_projectDetailLink.default, _unauthorized.default);
      return /*#__PURE__*/_react.default.createElement(DetailLink, {
        farmId: row.farmId,
        projectType: row.projectKey,
        create: !row.id,
        t: t,
        history: history,
        language: i18n.language
      });
    }
  }, {
    key: "projectChangeSetLink",
    value: function projectChangeSetLink(val, row) {
      var t = this.props.t;
      if (!row.id) return /*#__PURE__*/_react.default.createElement("span", null, "-");
      var projectKeyUC = row.projectKey.charAt(0).toUpperCase() + row.projectKey.slice(1);
      return /*#__PURE__*/_react.default.createElement(_gitChangesetLink.default, {
        changesetUrl: row.changeSet,
        text: t("".concat(projectKeyUC, " changeset link")),
        small: true
      });
    }
  }]);

  return ProjectStatusList;
}(_react.default.Component);

ProjectStatusList.defaultProps = {
  anchorId: 'project-status',
  ignoreProject: ''
};
ProjectStatusList.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }).isRequired,
  history: _propTypes.default.shape({}).isRequired,
  anchorId: _propTypes.default.string,
  userId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  ignoreProject: _propTypes.default.string
};
var _default = ProjectStatusList;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/project-status/index.js
// module id = 48
// module chunks = 0